import { Link } from "react-router-dom";
import { Phone, Mail, Clock, ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT, whatsappLink } from "@/data/site";
import { toFa } from "@/lib/fa";

const countryLinks = [
  { to: "/countries/usa", label: "پناهندگی و ویزای بشر دوستانه آمریکا" },
  { to: "/countries/canada", label: "پناهندگی و ویزای کاری کانادا" },
  { to: "/countries/australia", label: "پناهندگی و ویزای کاری استرالیا" },
  { to: "/countries/schengen", label: "پناهندگی و ویزای کاری حوزه شنگن" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-gold/15 bg-navy-900" data-testid="site-footer">
      <div className="gold-rule absolute inset-x-0 top-0" />
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div className="space-y-5">
          <Logo />
          <p className="text-sm leading-relaxed text-slate-400">
            گروه وکلای مهاجرت ۷ به مدیریت دکتر محمد احمدی؛ بیش از ۱۳ سال تجربه در وکالت تخصصی پناهندگی و ویزای بشر دوستانه و کاری — برای آمریکا، کانادا، استرالیا و حوزه شنگن.
          </p>
          <a href={whatsappLink("سلام، از وبسایت GM7 پیام می‌دهم.")} target="_blank" rel="noreferrer" className="btn-ghost !py-2.5 !text-xs" data-testid="footer-whatsapp-link">
            گفت‌وگو در واتساپ
          </a>
        </div>

        <div>
          <h4 className="mb-5 font-display text-base font-bold text-gold">دسترسی سریع</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            {[
              { to: "/", label: "صفحه اصلی" },
              { to: "/lawyers", label: "تیم وکلا" },
              { to: "/tracking", label: "رهگیری پرونده" },
              { to: "/blog", label: "وبلاگ و اخبار مهاجرت" },
              { to: "/faq", label: "سوالات متداول" },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="group flex items-center gap-2 transition-colors hover:text-gold" data-testid={`footer-quick-link-${l.to === "/" ? "home" : l.to.slice(1)}`}>
                  <ArrowLeft size={13} className="text-gold/50 transition-transform duration-300 group-hover:-translate-x-1" />
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-5 font-display text-base font-bold text-gold">مقاصد مهاجرتی</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            {countryLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="group flex items-center gap-2 transition-colors hover:text-gold" data-testid={`footer-country-link-${l.to.split("/").pop()}`}>
                  <ArrowLeft size={13} className="text-gold/50 transition-transform duration-300 group-hover:-translate-x-1" />
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-4 text-sm text-slate-300">
          <h4 className="mb-5 font-display text-base font-bold text-gold">ارتباط با ما</h4>
          <a href={`tel:${CONTACT.phonePrimaryIntl}`} className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-phone-link">
            <Phone size={16} className="shrink-0 text-gold" />
            <span dir="ltr">{CONTACT.phonePrimary} / {CONTACT.phoneSecondary}</span>
          </a>
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-email-link">
            <Mail size={16} className="shrink-0 text-gold" />
            <span dir="ltr">{CONTACT.email}</span>
          </a>
          <p className="flex items-start gap-3">
            <Clock size={16} className="mt-1 shrink-0 text-gold" />
            {CONTACT.supportNote}
          </p>
        </div>
      </div>

      <div className="border-t border-gold/10 py-6 text-center">
        <p className="text-xs text-slate-500">
          © {toFa(1404)} گروه وکلای مهاجرت ۷ — GM7 Immigration Law Group. تمامی حقوق محفوظ است.
        </p>
        <div className="mt-3 flex justify-center">
          <Link
            to="/admin"
            aria-label="ورود مدیر"
            title="ورود مدیر"
            className="block h-2.5 w-2.5 rounded-full bg-gold/35 transition-all duration-300 hover:scale-150 hover:bg-gold"
            data-testid="footer-admin-dot-link"
          />
        </div>
      </div>
    </footer>
  );
}
